import { Star, X, CheckCircle2 } from 'lucide-react';
import { StarPicker } from '../stars/Stars';

const ReviewModal = ({ onClose, jobId, reviewData, onReviewChange, onSubmit }) => {
  const rv = reviewData || {};
  return (
    <div className="mjobs-modal-overlay">
      <div className="mjobs-review-modal" onClick={e => e.stopPropagation()}>

        <div className="mjobs-review-modal__header">
          <div className="mjobs-review-modal__icon">
            <Star size={20} fill="#f59e0b" color="#f59e0b" />
          </div>
          <div>
            <h4 className="mjobs-review-modal__title">Rate & Review</h4>
            <p className="mjobs-review-modal__sub">Share your experience</p>
          </div>
          <button className="mjobs-dispute-modal__close" onClick={onClose}><X size={16} /></button>
        </div>

        <div className="mjobs-review-modal__body">
          <div className="mjobs-review-modal__stars-label">Your Rating</div>
          <StarPicker
            value={rv.rating || 0}
            onChange={val => onReviewChange(jobId, 'rating', val)}
          />
          <div className="mjobs-dispute-modal__field" style={{ marginTop: 16 }}>
            <label>Your Review</label>
            <textarea
              placeholder="Write your review..."
              value={rv.text || ''}
              onChange={e => onReviewChange(jobId, 'text', e.target.value)}
              rows={4}
            />
          </div>
        </div>

        <div className="mjobs-dispute-modal__footer">
          <button className="mjobs-dispute-modal__cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="mjobs-review-modal__submit-btn"
            onClick={() => { onSubmit(jobId); onClose(); }}
            disabled={!rv.rating}
          >
            <CheckCircle2 size={14} /> Submit & Complete
          </button>
        </div>

      </div>
    </div>
  );
};

export default ReviewModal;